// Empty on the server to avoid a timezone hydration mismatch.
export const formatDay = (iso: string): string => {
  if (typeof window === "undefined") return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleDateString(undefined, { dateStyle: "medium" });
};

export const formatTime = (iso: string): string => {
  if (typeof window === "undefined") return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleTimeString(undefined, { timeStyle: "short" });
};

export const isSameDay = (a: string, b: string): boolean => {
  const da = new Date(a);
  const db = new Date(b);
  if (Number.isNaN(da.getTime()) || Number.isNaN(db.getTime())) return false;
  return da.toDateString() === db.toDateString();
};

const pad = (n: number) => String(n).padStart(2, "0");

// A datetime-local value is local wall-clock with no zone. Emit an RFC3339
// string carrying the browser zone's offset so the instant survives the round
// trip; toISOString() would re-anchor to UTC and shift the wall-clock.
export const localToRfc3339 = (local: string): string => {
  const date = new Date(local);
  if (Number.isNaN(date.getTime())) return local;
  // getTimezoneOffset is minutes behind UTC, so it returns 300 for UTC-05:00.
  const offsetMinutes = -date.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? "+" : "-";
  const abs = Math.abs(offsetMinutes);
  const offset = `${sign}${pad(Math.floor(abs / 60))}:${pad(abs % 60)}`;
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}${offset}`
  );
};

// Drops the offset and seconds the datetime-local picker doesn't show.
export const rfc3339ToLocal = (iso: string): string => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
};

// All-day fields are date-only on both the wire and the picker, so dropping any
// trailing time passes the value through untouched.
export const dateOnly = (iso: string): string => (iso.includes("T") ? iso.slice(0, iso.indexOf("T")) : iso);
